import Simplex from './perlin'

const simplex = new Simplex()

// Current generated noise coordinates (Do not change)
const coordinates = new Array(3).fill([0, 0])

// Current drawing positions for our images
const drawingAt = new Array(3).fill([0, 0])

// Current image size after scale is applied
const drawnSizes = new Array(3).fill([0, 0])

// Offset for connection points relative to
// image size (0 = no offset, 1 = image width/height)
const offsets = [
  [
    [0.197, 0.19],
    [0.17, 0.235],
  ],
  [
    [0.85, 0.237],
    [0.8, 0.19],
  ],
  [
    [0.62, 0.813],
    [0.655, 0.81],
  ],
]

function perlin(t) {
  const w = this.canvas.width * this.settings.strength
  const h = this.canvas.height * this.settings.strength

  for (let i = 0; i < coordinates.length; i += 1) {
    coordinates[i] = [
      ((simplex.noise(i, t * 0.0005 * this.settings.speed) + 1) / 2) * w,
      ((simplex.noise(i + 1, t * 0.0005 * this.settings.speed) + 1) / 2) * h,
    ]
  }
}

function drawAtCoords(t) {
  const cvW = this.canvas.width
  const cvH = this.canvas.height
  // calculate a safe padding around the canvas
  // to ensure the logo shape is not going offscreen
  const safePaddingX = this.settings.strength * cvW
  const safePaddingY = this.settings.strength * cvH

  for (let i = 0; i < this.assets.length; i += 1) {
    const shape = this.assets[i]
    const shapeW = shape.width
    const shapeH = shape.height

    // Calculate the ratio between image and
    // canvas size subtracting the safe-padding
    const scaleW = (cvW - safePaddingX) / shapeW
    const scaleH = (cvH - safePaddingY) / shapeH

    // Get the minimum of the scales and use
    // as the general scale to ensure images
    // are rendered within bounds similar to
    // background-size: contain css property
    const maxScale = Math.min(scaleW, scaleH)
    // calculate the offset needed to center our renderings
    const offsetX = (cvW - safePaddingX - shape.width * maxScale) / 2
    const offsetY = (cvH - safePaddingY - shape.height * maxScale) / 2

    const [x, y] = coordinates[i]

    const [centerX, centerY] = [x + offsetX, y + offsetY]
    const drawSize = [shapeW * maxScale, shapeH * maxScale]
    this.context.drawImage(shape, centerX, centerY, ...drawSize)

    // store for later use to connect the dots
    drawingAt[i] = [centerX, centerY]
    drawnSizes[i] = [...drawSize]
  }
}

function connectLines() {
  this.context.strokeStyle = 'white'
  this.context.beginPath()

  for (let i = 0; i < drawingAt.length; i += 1) {
    const nextIndex = i + 1 > drawingAt.length - 1 ? 0 : i + 1
    // get the x, y positions for
    // our current and next image
    const [cX, cY] = drawingAt[i]
    const [nX, nY] = drawingAt[nextIndex]
    // get the width and height for
    // our current and next image
    const [cW, cH] = drawnSizes[i]
    const [nW, nH] = drawnSizes[nextIndex]
    // get the offsets relative to the
    // image size to create a drawing point
    const [outOffsetX, outOffsetY] = offsets[i][0]
    const [inOffsetX, inOffsetY] = offsets[nextIndex][1]

    this.context.moveTo(cX + cW * outOffsetX, cY + cH * outOffsetY)
    this.context.lineTo(nX + nW * inOffsetX, nY + nH * inOffsetY)
  }

  this.context.stroke()
}

export const animations = [perlin, drawAtCoords, connectLines]
export const assets = [
  require('./top-left.svg'),
  require('./top-right.svg'),
  require('./bottom.svg'),
]
export const settings = {
  speed: 0.2,
  strength: 0.1,
}
